import { render, staticRenderFns } from "./SearchAmendmentRow.vue?vue&type=template&id=696c40c4&scoped=true&"
import script from "./SearchAmendmentRow.vue?vue&type=script&lang=ts&"
export * from "./SearchAmendmentRow.vue?vue&type=script&lang=ts&"
import style0 from "./SearchAmendmentRow.vue?vue&type=style&index=0&id=696c40c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c40c4",
  null
  
)

export default component.exports